import { configureStore } from "./configureStore";

const { store } = configureStore({});

export { store };
